import { call, put } from 'redux-saga/effects';

import serviceLocator, { DASHBOARD_LITE_SVC } from '@APIs/common/service-locator';
import { fetchDashboardModelsLiteSuccess, fetchDashboardModelsLiteFail } from '@actions/dashboardLite/dashboardLiteActionCreators';

export function* fetchDashboardModelsLiteAsync () {
    try {
        const dashboardLiteService = yield call(serviceLocator, DASHBOARD_LITE_SVC);
        const dashboardModels = yield call([dashboardLiteService, dashboardLiteService.fetchDashboardModelsLite]);

        yield put(fetchDashboardModelsLiteSuccess(dashboardModels));
    } catch (e) {
        yield put(fetchDashboardModelsLiteFail(e));
    }
}

